import { render, staticRenderFns } from "./SesionesFormativaData.vue?vue&type=template&id=d496ae7a&"
import script from "./SesionesFormativaData.vue?vue&type=script&lang=js&"
export * from "./SesionesFormativaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports